// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createStore } from "effector";
import { deleteUser, setUsers, updateUser } from "./UserManagementEvents";
import { UserInfoResponseDTO } from "../../api/backend-openapi";

export const UserManagementStore = createStore<UserInfoResponseDTO[]>([])
  .on<UserInfoResponseDTO[]>(
    setUsers,
    (state: UserInfoResponseDTO[], payload: UserInfoResponseDTO[]) => payload
  )
  .on<string>(deleteUser, (state: UserInfoResponseDTO[], payload: string) =>
    state.filter(user => user.id !== payload)
  )
  .on<UserInfoResponseDTO>(
    updateUser,
    (state: UserInfoResponseDTO[], payload: UserInfoResponseDTO) => [
      ...state.filter(user => user.id !== payload.id),
      payload
    ]
  );
